import { create } from "zustand"
import { persist } from "zustand/middleware"

interface ViewState {
  browseScrollPosition: number
  activeSetId: string | null
  isReturningToBrowse: boolean
  saveViewState: (scrollPosition: number, activeSetId: string | null) => void
  getViewState: () => { scrollPosition: number; activeSetId: string | null }
  clearViewState: () => void
  setReturningToBrowse: (value: boolean) => void
}

export const useViewStateStore = create<ViewState>()(
  persist(
    (set, get) => ({
      browseScrollPosition: 0,
      activeSetId: null,
      isReturningToBrowse: false,

      saveViewState: (scrollPosition: number, activeSetId: string | null) => {
        set({
          browseScrollPosition: scrollPosition,
          activeSetId,
        })
      },

      getViewState: () => {
        const state = get()
        return {
          scrollPosition: state.browseScrollPosition,
          activeSetId: state.activeSetId,
        }
      },

      clearViewState: () => {
        set({
          browseScrollPosition: 0,
          activeSetId: null,
        })
      },

      setReturningToBrowse: (value: boolean) => {
        set({ isReturningToBrowse: value })
      },
    }),
    {
      name: "view-state",
    },
  ),
)
